import {
  BusStoreEmojisTTF,
} from '../fonts';

export const flagIconFont = `
    @font-face {
      font-family: 'busstore-emojis';
      src: url('${BusStoreEmojisTTF}');
    }
`;
